import { combineReducers } from 'redux';
import addOrder from './addOrder';
import appReducer from './appReducer';
import detailShipment from './detailShipment';
import editOrder from './editOrder';
import getListCountry from './getListCountry';
import getListCurrency from './getListCurrency';
import getListItemName from './getListItemName';
import headerReducer from './headerReducer';
import ordersReducer from './ordersReducer';
import quickSearchReducer from './quickSearchReducer';
import settingAccountReducer from './settingAccountReducer';
import settingChannelReducer from './settingChannelReducer';
import settingMerchantReducer from './settingMerchantReducer';
import settingPrinterReducer from './settingPrinterReducer';
import settingOAuthReducer from './settingOAuthReducer';
import shipmentReducer from './shipmentReducer';
import syncReducer from './syncReducer';
import prohibitedItems from './prohibitedItems';

export default combineReducers({
    syncReducer,
    addOrder,
    settingChannelReducer,
    settingPrinterReducer,
    settingMerchantReducer,
    settingAccountReducer,
    settingOAuthReducer,
    ordersReducer,
    quickSearchReducer,
    headerReducer,
    shipmentReducer,
    getListItemName,
    getListCurrency,
    getListCountry,
    editOrder,
    detailShipment,
    appReducer,
    prohibitedItems,
})



// WEBPACK FOOTER //
// ./src/reducers/index.js